import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import { LoginLoader } from "../loginloader/LoginLoader"
import "./Login.css"

export default function Login({ setIsLoggedIn }) {

  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState("loading")

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {

    e.preventDefault();

    setLoading(true)
    setStatus("loading")

    try {
      const response = await API.post("/api/auth/login", {
        email,
        password
      })

      const userToken = response.data;

      localStorage.setItem("userToken", userToken);
      setIsLoggedIn(true)

      setStatus("success")

      setTimeout(() => {
        navigate("/")
      }, 500)
    } catch (error) {

      setStatus("error")
      setTimeout(() => {
        setLoading(false)
      }, 1500)
      console.error(error)
    }
  }

  return (
    <>
      {loading && <LoginLoader status={status} />}

      <div className="login-page">

        {/* Background Gradient */}
        <div className="login-gradient"></div>

        {/* Keep your existing animated circles */}
        <div className="circle circle1"></div>
        <div className="circle circle2"></div>
        <div className="circle circle3"></div>
        <div className="circle circle4"></div>

        <div className="page-container">

          <div className="row align-items-center justify-content-center min-vh-100">

            {/* Left Section */}

            <div className="col-lg-6 d-none d-lg-flex">

              <div className="hero-section">

                <div className="brand-logo">

                  <div className="logo-circle">
                    🛍
                  </div>

                  <h1>ShopSphere</h1>

                </div>

                <h2>
                  Shop Smarter.
                  <br />
                  Live Better.
                </h2>

                <p>
                  Discover thousands of premium products with lightning-fast
                  delivery, secure payments, and AI-powered shopping.
                </p>

                <div className="hero-features">

                  <div className="feature-item">
                    <span>✨</span>
                    <div>
                      <h5>AI Product Search</h5>
                      <p>Find exactly what you need instantly.</p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <span>🚚</span>
                    <div>
                      <h5>Fast Delivery</h5>
                      <p>Delivered quickly to your doorstep.</p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <span>🔒</span>
                    <div>
                      <h5>Secure Payments</h5>
                      <p>Your payments are encrypted & protected.</p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <span>🏆</span>
                    <div>
                      <h5>Trusted Brands</h5>
                      <p>Shop from your favourite brands.</p>
                    </div>
                  </div>

                </div>

              </div>

            </div>

            {/* Login Card */}

            <div className="col-lg-5 col-md-8 col-sm-11">

              <div className="login-card">

                <div className="login-header">

                  <div className="mobile-logo d-lg-none">
                    🛍
                  </div>

                  <h2>Welcome Back 👋</h2>

                  <p>
                    Login to continue your shopping journey.
                  </p>

                </div>

                <form onSubmit={handleLogin}>

                  {/* Email */}

                  <div className="input-group-custom">

                    <span className="input-icon">
                      <i className="bi bi-envelope-fill"></i>
                    </span>

                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />

                  </div>

                  {/* Password */}

                  <div className="input-group-custom">

                    <span className="input-icon">
                      <i className="bi bi-lock-fill"></i>
                    </span>

                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />

                  </div>

                  <div className="text-end mb-3">

                    <button
                      type="button"
                      className="forgot-link"
                      onClick={() => {
                        // TODO: Navigate to forgot password page
                      }}
                    >
                      Forgot Password?
                    </button>

                  </div>

                  {/* Login */}

                  <button
                    disabled={loading}
                    className="btn login-btn w-100"
                  >
                    Login
                  </button>

                  <div className="divider">

                    <span>OR</span>

                  </div>

                  {/* Guest */}

                  <button
                    type="button"
                    className="btn guest-btn w-100"
                    onClick={() => navigate("/")}
                  >
                    🛍 Continue as Guest
                  </button>

                  {/* Register */}

                  <div className="register-text">

                    Don't have an account?

                    <button
                      disabled={loading}
                      type="button"
                      className="register-link"
                      onClick={() => navigate("/register")}
                    >
                      Create Account →
                    </button>

                  </div>

                </form>

              </div>

            </div>

          </div>

        </div>

      </div>

    </>
  );
}